export const DELIVERY_PASS_UNKNOWN = 'UNKNOWN';
export const DELIVERY_PASS_ACTIVE = 'ACTIVE';
export const DELIVERY_PASS_AVAILABLE = 'AVAILABLE';
